// Image bank for the AI concierge — official MODULAROOM Gemini renders only.
const A = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_modularoom-design/artifacts/';

export const IMAGE_BANK = {
  capsule: [
    `${A}9zd8mcz0_6b5cca98-d5ef-4b59-a728-583b38b016b3.webp`,   // CS31 lake dawn hero
    `${A}qalnrf4h_d1498605-415f-432c-8527-70a729ccf41a.jpeg`,    // CS33 night cliff hero
    `${A}5b5mzuzp_Gemini%20CS37%203.png`,                        // CS37 vineyard sunrise
    `${A}2smyw1x1_Gemini%20CS25%201.png`,                        // CS25 lake nightscape
  ],
  studio: [
    `${A}sk989pgq_Gemini%20SS35%201%281%29.webp`,                // SS35 golden hills widescreen
    `${A}78ce6kbh_Gemini%20SS26%201.PNG`,                        // SS26 wide oak meadow
    `${A}sohjvoio_Gemini%20SS32%201%281%29.webp`,                // SS32 foggy pine forest
    `${A}rc6k31cx_Gemini%20SS35%204%281%29.png`,                 // SS35 aerial forest firepit
  ],
  interior: [
    `${A}f8xbyl9y_Gemini%20SS35%203%281%29.png`,                 // SS35 warm sunset interior
    `${A}78n4jy02_Gemini%20SS26%207%281%29.webp`,                // SS26 desk interior warm
    `${A}wxl645er_Gemini%20SS32%204%281%29.webp`,                // SS32 bedroom forest view
    `${A}55ne26xl_Gemini%20SS32%205%281%29.webp`,                // SS32 living room interior
    `${A}gsn05nue_Gemini%20CS33%205%281%29.png`,                 // CS33 moody ocean interior
  ],
  resort: [
    `${A}9zd8mcz0_6b5cca98-d5ef-4b59-a728-583b38b016b3.webp`,   // CS31 hero
    `${A}iq7yl1ww_Gemini%20CS31%203%281%29.webp`,                // CS31 morning stone path
    `${A}5b5mzuzp_Gemini%20CS37%203.png`,                        // CS37 vineyard
    `${A}9u7la3o6_Gemini%20CS33%202%281%29.png`,                 // CS33 rain sunset
  ],
  glamping: [
    `${A}2smyw1x1_Gemini%20CS25%201.png`,                        // CS25 lake nightscape
    `${A}z45vnehk_Gemini%20CS25%202%281%29.png`,                 // CS25 forest morning
    `${A}162bi3cc_Gemini%20CS25%204%281%29.png`,                 // CS25 dusk symmetric
    `${A}pdn3tjcn_Gemini%20CS37%201%281%29.webp`,                // CS37 firepit twilight
  ],
  office: [
    `${A}kox199f2_Gemini%20SS26%206.png`,                        // SS26 twilight exterior
    `${A}78n4jy02_Gemini%20SS26%207%281%29.webp`,                // SS26 desk interior
    `${A}fmkls9lj_Gemini%20SS26%208%281%29.webp`,                // SS26 aluminium detail
    `${A}zrac6vu6_Gemini%20SS26%209%281%29.webp`,                // SS26 aerial oak canopy
  ],
};

export function resolveImages(keys = []) {
  const out = [];
  keys.forEach((k) => {
    const arr = IMAGE_BANK[String(k).toLowerCase()];
    if (arr) arr.forEach((u) => { if (!out.includes(u)) out.push(u); });
  });
  return out.slice(0, 6);
}
